import React from 'react';
import { FileText, Download } from 'lucide-react';

// Documentation officielle du fabricant : album PDF de la voiture, à télécharger.
export default function ProductPdfCard({ pdfUrl, productName }) {
  if (!pdfUrl) return null;

  return (
    <div className="mt-12">
      <a
        href={pdfUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-4 p-4 rounded-xl border border-gray-200 hover:border-cs-blue hover:bg-cs-blue/5 transition-colors group"
      >
        <div className="w-11 h-11 rounded-lg bg-cs-blue/10 flex items-center justify-center shrink-0">
          <FileText className="w-5 h-5 text-cs-blue" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-display font-bold text-sm text-gray-900">ALBUM OFFICIEL (PDF)</p>
          <p className="text-xs text-gray-500">
            Documentation officielle du fabricant pour {productName}
          </p>
        </div>
        <span className="flex items-center gap-1.5 text-sm font-bold text-cs-blue shrink-0">
          <Download className="w-4 h-4" /> TÉLÉCHARGER
        </span>
      </a>
    </div>
  );
}